import { Col, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Add, Cancel } from "../../../../utils/Constant";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const ButtonSection = () => {
  const location = useLocation();
  const currentPathname = location.pathname;
  const isAuthor = currentPathname.includes("/authors");
  return (
    <Row>
      <Col>
        <div className="text-end">
          <Btn color="success" type="submit" className="me-3">
            {"Edit"}
          </Btn>
          <Link to={`${isAuthor ? "/authors" : "/users"}/cards`}>
            <Btn color="danger">{Cancel}</Btn>
          </Link>
        </div>
      </Col>
    </Row>
  );
};

export default ButtonSection;
